import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, MessageSquare, BarChart3, Edit3 } from 'lucide-react';

const CommunicationsSection = ({
  setShowBulkEmailModal,
  handleSendWeeklyReports
}) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Communications</h1>
          <p className="text-gray-500">Send messages and email campaigns</p>
        </div>
        <button 
          onClick={() => setShowBulkEmailModal(true)}
          className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
          data-testid="send-bulk-email-btn"
        >
          <Mail className="w-5 h-5" />
          Send Bulk Email
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
        <button 
          onClick={() => setShowBulkEmailModal(true)}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <Mail className="w-10 h-10 text-purple-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Send Bulk Email</h3>
          <p className="text-gray-500 text-sm">Send personalized emails to all mentees</p>
        </button>
        
        <button 
          onClick={() => navigate('/community')}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <MessageSquare className="w-10 h-10 text-blue-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Community Announcements</h3>
          <p className="text-gray-500 text-sm">Post in community channels</p>
        </button>
        
        <button 
          onClick={handleSendWeeklyReports}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <BarChart3 className="w-10 h-10 text-green-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Weekly Progress Reports</h3>
          <p className="text-gray-500 text-sm">Send progress summaries to all mentees</p>
        </button>
        
        <button 
          onClick={() => navigate('/dashboard')}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <Edit3 className="w-10 h-10 text-orange-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Welcome Message</h3>
          <p className="text-gray-500 text-sm">Edit the dashboard encouragement message</p>
        </button>
      </div>
    </div>
  );
};

export default CommunicationsSection;
